// src/components/custom/screenplay/editor/plugins/EditorInstancePlugin.tsx

import { useSceneStore } from '@/features/shared/stores/scene.store'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { COMMAND_PRIORITY_HIGH, KEY_BACKSPACE_COMMAND } from 'lexical'
import { useEffect } from 'react'
export function SpEditorInstancePlugin() {
    const [editor] = useLexicalComposerContext()
    const { setEditor } = useSceneStore()

    useEffect(() => {
        setEditor(editor)
        editor?.focus()
    }, [editor])

    useEffect(() => {
        const removeIfEmpty = (e: KeyboardEvent) => {
            //TODO handle this to make inconvenient backspace experience caused due to insertion of zero width character

            return false
        }

        const removeDelete = editor.registerCommand(
            KEY_BACKSPACE_COMMAND,
            removeIfEmpty,
            COMMAND_PRIORITY_HIGH
        )

        return () => {
            removeDelete()
        }
    }, [editor])

    return null
}
